__turbopack_context__.v({
  "cell": "table-module-scss-module__clSbRG__cell",
  "center": "table-module-scss-module__clSbRG__center",
  "clickable": "table-module-scss-module__clSbRG__clickable",
  "left": "table-module-scss-module__clSbRG__left",
  "loading": "table-module-scss-module__clSbRG__loading",
  "noData": "table-module-scss-module__clSbRG__noData",
  "pagination": "table-module-scss-module__clSbRG__pagination",
  "right": "table-module-scss-module__clSbRG__right",
  "row": "table-module-scss-module__clSbRG__row",
  "withHover": "table-module-scss-module__clSbRG__withHover",
  "wrapper": "table-module-scss-module__clSbRG__wrapper",
});
